"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adaptor34 = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
var v0_34_1 = require("./v0-34");
Object.defineProperty(exports, "adaptor34", { enumerable: true, get: function () { return v0_34_1.v0_34; } });
//# sourceMappingURL=index.js.map